import { Injectable } from '@angular/core';

@Injectable()
export class Constants {
    public static PROD = 'prod';
    public static TEST = 'test';
    public static DEV = 'dev';

    public static TIMER_MIN_FIVE = 300000;
    public static TIMER_MIN_TWO = 120000;
    public static TIMER_MIN_ONE = 60000;
    public static TIMER_SEC_THIRTY = 30000;

    //#region ENDPOINTS
    /* auth */
    public static API_PORTAL_TOKEN_CREATE = 'portal/auth/create';
    public static API_PORTAL_TOKEN_VERIFY = 'portal/auth/verify';
    public static API_PORTAL_TOKEN_RENEW = 'portal/auth/renew';

    /* portal */
    public static API_PORTAL_USER = 'portal/user';
    public static API_PORTAL_USER_PASSWORD_UPDATE = 'portal/user/password/update';
    public static API_PORTAL_USER_UPDATE = 'portal/user/update';
    public static API_PORTAL_ORDERS = 'portal/orders';
    public static API_PORTAL_CASE_HISTORY = 'portal/case/history';
    public static API_PORTAL_ORDERS_CONFIRM = 'portal/orders/confirm';
    public static API_PORTAL_ORDERS_UNCONFIRM = 'portal/orders/unconfirm';
    public static API_PORTAL_ORDER_LOOKUP = 'portal/order/lookup';
    public static API_PORTAL_ORDER_ADD = 'portal/order/add';
    public static API_PORTAL_CONTACT = 'portal/contact';
    public static API_PORTAL_SCHEDULE_CASE_DATE = 'portal/schedule-case-date';
    public static API_PORTAL_ORDER = 'portal/order';
    public static API_PORTAL_ORDER_CASE_UPDATE = 'portal/order/case/update';
    public static API_PORTAL_ORDER_UPDATE = 'portal/order/update';
    public static API_API_PORTAL_CANCEL = 'portal/order/cancel';
    public static API_PORTAL_ORDER_DETAILS_LOOKUP = 'portal/order/details/lookup';
    public static API_PORTAL_VENDORREPORTS = 'portal/vendor-reports';
    public static API_REPORT_FUJIFILM_REVENUE_SHARE = 'report/fujifilm/revenue-share';
    //#endregion

    public static IT_SUPPORT_EMAIL = 'itsupport@fortecmedical.com';

    public static SYNCFUSION_LICENSE = 'ORg4AjUWIQA/Gnt2VVhhQlFacF5JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0RiWH5bdXVXQmhUUkc=';
}
